module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n            ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Freight WareHouse Execution\n            "), _c('small', {
    staticClass: "ml-2"
  }, [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v(_vm._s(_vm.ffExportDetail.portType == "Icd" ?
    " Stuffing At ICD" :
    " Stuffing At PORT (Port Stuffing)"))])], 1)])], 1), _vm._v(" "), (_vm.ALLMODULE) ? _c('banner-component', {
    attrs: {
      "allModuleIdBanner": _vm.ALLMODULE,
      "jobSeriesBanner": _vm.JOBSERIES,
      "bannerClientName": _vm.mainEntryData.length > 0 ? _vm.mainEntryData[0].clientName : '',
      "iconId": "fa fa-ship"
    }
  }) : _vm._e(), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', [_c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "size": "sm",
      "variant": "dark"
    },
    on: {
      "click": _vm.showDocModal
    }
  }, [_vm._v("Upload Documents")]), _vm._v(" "), (_vm.ALLMODULE) ? _c('container-component', {
    attrs: {
      "allModuleIdContainer": _vm.ALLMODULE,
      "JOB": "FF"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.proceedNext == '1') ? _c('div', [_c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("WareHouse Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "formatter": _vm.capitalizeAll,
      "name": "nameOfCFS",
      "id": "nameOfCFS"
    },
    model: {
      value: (_vm.WarehouseStuffing.nameOfCFS),
      callback: function($$v) {
        _vm.$set(_vm.WarehouseStuffing, "nameOfCFS", $$v)
      },
      expression: "WarehouseStuffing.nameOfCFS"
    }
  })], 1), _vm._v(" "), (!_vm.WarehouseStuffing.nameOfCFS) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.nameOfCFSError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("VGM Submission Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "vgmSubmissionDate",
      "id": "vgmSubmissionDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.WarehouseStuffing.vgmSubmissionDate),
      callback: function($$v) {
        _vm.$set(_vm.WarehouseStuffing, "vgmSubmissionDate", $$v)
      },
      expression: "WarehouseStuffing.vgmSubmissionDate"
    }
  }), _vm._v(" "), (_vm.WarehouseStuffing.vgmSubmissionDate_err) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.WarehouseStuffing.vgmSubmissionDate_err))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "gateInDate"
    }
  }, [_vm._v("SI Submission date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "lang": "en",
      "id": "gateInDate",
      "type": "datetime",
      "format": "YYYY-MM-DD hh:mm a",
      "minute-step": 1,
      "name": "gateInDate"
    },
    model: {
      value: (_vm.WarehouseStuffing.siSubmissionDate),
      callback: function($$v) {
        _vm.$set(_vm.WarehouseStuffing, "siSubmissionDate", $$v)
      },
      expression: "WarehouseStuffing.siSubmissionDate"
    }
  }), _vm._v(" "), (_vm.WarehouseStuffing.siSubmissionDate_err) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.WarehouseStuffing.siSubmissionDate_err))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "trSubmissionDate"
    }
  }, [_vm._v("TR Submission date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "lang": "en",
      "id": "trSubmissionDate",
      "type": "datetime",
      "format": "YYYY-MM-DD hh:mm a",
      "minute-step": 1,
      "name": "trSubmissionDate"
    },
    model: {
      value: (_vm.WarehouseStuffing.trSubmissionDate),
      callback: function($$v) {
        _vm.$set(_vm.WarehouseStuffing, "trSubmissionDate", $$v)
      },
      expression: "WarehouseStuffing.trSubmissionDate"
    }
  }), _vm._v(" "), (_vm.WarehouseStuffing.trSubmissionDate_err) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.WarehouseStuffing.trSubmissionDate_err))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Handover Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "handoverDate",
      "id": "handoverDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.WarehouseStuffing.handoverDate),
      callback: function($$v) {
        _vm.$set(_vm.WarehouseStuffing, "handoverDate", $$v)
      },
      expression: "WarehouseStuffing.handoverDate"
    }
  }), _vm._v(" "), (_vm.WarehouseStuffing.handoverDate_err) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.WarehouseStuffing.handoverDate_err))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }), _vm._v(" "), (_vm.ffExportDetail.portType == 'Icd') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_c('u', [_vm._v("Custom Clearance")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.ffExportDetail.portType == 'Icd') ? _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "custmClearByPridel"
    }
  }, [_vm._v("CC to be done by Pridel")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.viewPagePref == 1,
      "list": _vm.CCList,
      "option-value": "ccInfoVal",
      "option-text": "ccInfoText",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.WarehouseStuffing.custmClearByPridel),
      callback: function($$v) {
        _vm.$set(_vm.WarehouseStuffing, "custmClearByPridel", $$v)
      },
      expression: "WarehouseStuffing.custmClearByPridel"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("CC Assignment No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "formatter": _vm.capitalizeAll,
      "name": "ccAsignmentNo",
      "id": "ccAsignmentNo"
    },
    model: {
      value: (_vm.WarehouseStuffing.ccAsignmentNo),
      callback: function($$v) {
        _vm.$set(_vm.WarehouseStuffing, "ccAsignmentNo", $$v)
      },
      expression: "WarehouseStuffing.ccAsignmentNo"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('b-button', {
    staticClass: "mt-3 smbutnWidth",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderVGM"
    },
    on: {
      "click": function($event) {
        _vm.addFactoryExecution('SAVE')
      }
    }
  }, [_vm._v("Save & Submit")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderVGM"
    }
  })], 1), _vm._v(" "), _c('b-row', [(_vm.ALLMODULE) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('UpdateContainerWithSOB', {
    attrs: {
      "allModuleId": Number(_vm.ALLMODULE),
      "JobNo": _vm.JOBSERIES
    },
    on: {
      "update": _vm.getData
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('div', {
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.AppovalMSG) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.AppovalMSG))]) : _vm._e(), _c('br'), _vm._v(" "), _c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderVGM"
    },
    on: {
      "click": function($event) {
        _vm.addFactoryExecution('PAYTEST')
      }
    }
  }, [_vm._v("Save & Proceed To S-Line Payment")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderVGM"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.ALLMODULE && _vm.is_approval_mail_action > 0) ? _c('ResetSlineSubscription', {
    attrs: {
      "allModuleId": Number(_vm.ALLMODULE),
      "JobNo": _vm.JOBSERIES
    },
    on: {
      "refresh-data": _vm.getData
    }
  }) : _vm._e(), (_vm.ALLMODULE && _vm.is_approval_mail_action > 0) ? _c('br') : _vm._e()], 1), _vm._v(" "), _c('div', {
    attrs: {
      "md-gutter": ""
    }
  }, [(!_vm.ffExportDetail.mergeffExportId ||
    _vm.ffExportDetail.mergeffExportId == 0
  ) ? _c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderBL"
    },
    on: {
      "click": function($event) {
        _vm.addFactoryExecution('BLRaised')
      }
    }
  }, [_vm._v("Save & Proceed\n                    to Raise B/L")]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderBL"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderRail"
    },
    on: {
      "click": function($event) {
        _vm.addFactoryExecution('handover')
      }
    }
  }, [_vm._v(_vm._s(_vm.ffExportDetail.portType == "Icd" ?
    "Save & Proceed to Handover to Rail" :
    "Save & Proceed to Gate ­ in at Terminal By Road"))]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderRail"
    }
  }), _vm._v(" "), _c('br')], 1)])], 1) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), (_vm.ALLMODULE) ? _c('div', [_c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": ""
    }
  }, [_c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n        ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popMail",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.sendMail
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popMailAfter",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose6
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop7",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose7
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop2",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be32205c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/freightForwarding/newFFExecutionWareHouse.vue
// module id = 2850
// module chunks = 0